import { useTranslation } from "react-i18next";
import { Alert, Button } from "@akuna/ui";

export type StayPlanCoverageChoice = "plan" | "avulso";

/**
 * Aparece no check-in quando o plano do pet não cobre mais a diária (saldo
 * esgotado). Nada é decidido automaticamente: o atendente escolhe entre
 * vincular/contratar um plano novo ou cobrar a diária avulsa na comanda.
 */
export function StayPlanCoverageStep({
  dailyRate,
  onChoose,
  onContractPlan,
}: {
  dailyRate: number | null;
  onChoose: (choice: StayPlanCoverageChoice) => void;
  onContractPlan: () => void;
}) {
  const { t } = useTranslation("daycareHotel");

  return (
    <Alert variant="warning" className="grid gap-3">
      <p className="text-sm font-medium">{t("planCoverage.uncoveredTitle")}</p>
      <p className="text-sm text-muted-foreground">{t("planCoverage.uncoveredHint")}</p>
      <div className="flex flex-wrap gap-2">
        <Button type="button" variant="outline" onClick={onContractPlan}>
          {t("planCoverage.contractPlan")}
        </Button>
        <Button type="button" onClick={() => onChoose("avulso")}>
          {dailyRate === null
            ? t("planCoverage.chargeAvulso")
            : t("planCoverage.chargeAvulsoWithRate", { rate: dailyRate })}
        </Button>
      </div>
    </Alert>
  );
}
